(() => {
function $8cf091426121561b$export$c92e8f569ad2976f() {
    const test = "Tabs boy";
}


function $79162cbf328500a8$export$60523367a7e10402() {
    const test = "Modal boy";
}


function $e5a0c706c63f0a8e$export$d75bb3493b7a8511() {
    const navbar = document.querySelector(".navbar");
    const topbar = document.querySelector(".topbar");
    const hamburger = document.querySelector(".navbar__hamburger");
    const mobileMenu = document.querySelector(".navbar__menu");
    //STICKY MENU ON SCROLL
    let lastScrollTop = 0;
    window.addEventListener("scroll", function() {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
            // Scrolling down
            navbar.classList.add("scrolled");
            topbar.style.transform = "translateY(-100%)";
        } else {
            // Scrolling up
            navbar.classList.remove("scrolled");
            topbar.style.transform = "translateY(0)";
        }
    });
    //RESPONSIVE MENU - MOBILE MENU
    // Toggle menu on hamburger click
    hamburger?.addEventListener("click", ()=>{
        hamburger.classList.toggle("active");
        mobileMenu?.classList.toggle("active");
    });
    // Handle submenu toggles for mobile
    const menuItems = document.querySelectorAll(".navbar__item");
    menuItems.forEach((item)=>{
        const submenu = item.querySelector(".navbar__submenu");
        if (submenu) {
            const button = item.querySelector("button.navbar__link");
            button?.addEventListener("click", (e)=>{
                // Only toggle on mobile
                if (window.innerWidth <= 900) {
                    e.preventDefault();
                    submenu.classList.toggle("active");
                }
            });
        }
    });
    // Close menu when clicking outside
    document.addEventListener("click", (e)=>{
        if (!e.target.closest(".navbar__menu") && !e.target.closest(".navbar__hamburger") && mobileMenu?.classList.contains("active")) {
            mobileMenu.classList.remove("active");
            hamburger?.classList.remove("active");
        }
    });
}


function $8e010fcd1137ce21$export$90bcfd3ae0065ad7() {
    const languageBtn = document.querySelector(".language-btn");
    const languageDropdown = document.querySelector(".language-dropdown");
    if (languageBtn && languageDropdown) {
        // Initially hide dropdown
        languageDropdown.style.display = "none";
        languageBtn.addEventListener("click", (e)=>{
            e.stopPropagation();
            // Open or close the language dropdown
            languageDropdown.style.display = languageDropdown.style.display === "none" ? "block" : "none";
        });
        // Close dropdown when clicking outside
        document.addEventListener("click", (e)=>{
            if (!languageBtn.contains(e.target) && !languageDropdown.contains(e.target)) languageDropdown.style.display = "none";
        });
    }
}


function $ce4483e0d240611b$export$875c44e8a8aa0039() {
    // Check if browser supports IntersectionObserver
    if ("IntersectionObserver" in window) {
        // Handle regular images with src attribute
        const lazyImages = document.querySelectorAll('img[loading="lazy"]');
        const imageObserver = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const img = entry.target;
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.removeAttribute("data-src");
                    }
                    observer.unobserve(img);
                }
            });
        }, {
            rootMargin: "50px 0px",
            threshold: 0.01
        });
        lazyImages.forEach((img)=>imageObserver.observe(img));
        // Handle background images
        const lazyBackgrounds = document.querySelectorAll("[data-background]");
        const bgObserver = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const element = entry.target;
                    if (element.dataset.background) {
                        element.style.backgroundImage = `url(${element.dataset.background})`;
                        element.removeAttribute("data-background");
                    }
                    observer.unobserve(element);
                }
            });
        }, {
            rootMargin: "50px 0px",
            threshold: 0.01
        });
        lazyBackgrounds.forEach((element)=>bgObserver.observe(element));
    } else {
        // Fallback for browsers that don't support IntersectionObserver
        const loadImages = ()=>{
            const lazyImages = document.querySelectorAll('img[loading="lazy"]');
            const lazyBackgrounds = document.querySelectorAll("[data-background]");
            // Load regular images
            lazyImages.forEach((img)=>{
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    img.removeAttribute("data-src");
                }
            });
            // Load background images
            lazyBackgrounds.forEach((element)=>{
                if (element.dataset.background) {
                    element.style.backgroundImage = `url(${element.dataset.background})`;
                    element.removeAttribute("data-background");
                }
            });
        };
        // Load all images after a short delay
        setTimeout(loadImages, 100);
    }
}


function $3867e9684d981eab$export$99e00de73f33b819(element, options = {}) {
    if (!element) {
        console.warn("Carousel element not found");
        return;
    }
    element.style.cssText = `
    position: relative;
    overflow: hidden;
  `;
    const container = element.querySelector(".carousel__container");
    const slides = Array.from(container.children);
    const prevArrow = element.querySelector(".carousel__arrow--prev");
    const nextArrow = element.querySelector(".carousel__arrow--next");
    const dots = Array.from(element.querySelectorAll(".dot"));
    const carouselOptions = {
        slidesPerView: options.slidesPerView || 1,
        spaceBetween: options.spaceBetween || 20,
        loop: true,
        breakpoints: options.breakpoints || null
    };
    let currentIndex = 0;
    let slideWidth = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    let startTranslate = 0;
    let currentTranslate = 0;
    let autoplayTimeoutId = null;
    let isHovered = false;
    const autoplayOptions = {
        enabled: options.autoplay?.enabled ?? true,
        delay: options.autoplay?.delay ?? 5000,
        pauseOnHover: options.autoplay?.pauseOnHover ?? true
    };
    function calculateSlideWidth() {
        const totalGaps = (carouselOptions.slidesPerView - 1) * carouselOptions.spaceBetween;
        slideWidth = (container.offsetWidth - totalGaps) / carouselOptions.slidesPerView;
    }
    function setupSlides() {
        // Clear existing clones
        const clones = container.querySelectorAll(".clone");
        clones.forEach((clone)=>clone.remove());
        // Recalculate slide width
        calculateSlideWidth();
        // Clone first and last slides
        const firstSlideClone = slides[0].cloneNode(true);
        const lastSlideClone = slides[slides.length - 1].cloneNode(true);
        // Mark clones for easy removal
        firstSlideClone.classList.add("clone");
        lastSlideClone.classList.add("clone");
        container.appendChild(firstSlideClone);
        container.insertBefore(lastSlideClone, slides[0]);
        const allSlides = Array.from(container.children);
        allSlides.forEach((slide)=>{
            slide.style.cssText = `
        flex: 0 0 ${slideWidth}px;
        margin-right: ${carouselOptions.spaceBetween}px;
      `;
        });
        goToSlide(1, false);
    }
    function checkResponsive() {
        if (carouselOptions.breakpoints) {
            const windowWidth = window.innerWidth;
            Object.keys(carouselOptions.breakpoints).sort((a, b)=>b - a).forEach((breakpoint)=>{
                if (windowWidth <= breakpoint) carouselOptions.slidesPerView = carouselOptions.breakpoints[breakpoint].slidesPerView;
            });
        }
    }
    function updateDots(index) {
        if (dots.length) {
            dots.forEach((dot)=>dot.classList.remove("active"));
            const normalizedIndex = index < 0 ? dots.length - 1 : index >= dots.length ? 0 : index;
            dots[normalizedIndex].classList.add("active");
        }
    }
    function goToSlide(index, smooth = true) {
        if (!smooth) container.style.transition = "none";
        else container.style.transition = "transform 0.3s ease-in-out";
        currentIndex = index;
        currentTranslate = -(index * (slideWidth + carouselOptions.spaceBetween));
        container.style.transform = `translateX(${currentTranslate}px)`;
        if (!smooth) setTimeout(()=>{
            container.style.transition = "transform 0.3s ease-in-out";
        }, 50);
        updateDots(index - 1);
    }
    function next() {
        const maxIndex = slides.length + 1;
        if (currentIndex >= maxIndex) {
            goToSlide(1, false);
            setTimeout(()=>goToSlide(2), 50);
        } else goToSlide(currentIndex + 1);
    }
    function prev() {
        if (currentIndex <= 0) {
            goToSlide(slides.length, false);
            setTimeout(()=>goToSlide(slides.length - 1), 50);
        } else goToSlide(currentIndex - 1);
    }
    function startAutoplay() {
        if (!autoplayOptions.enabled || isHovered) return;
        if (autoplayTimeoutId) clearTimeout(autoplayTimeoutId);
        autoplayTimeoutId = setTimeout(()=>{
            if (!isDragging && !isHovered) {
                next();
                startAutoplay();
            }
        }, autoplayOptions.delay);
    }
    function stopAutoplay() {
        if (autoplayTimeoutId) {
            clearTimeout(autoplayTimeoutId);
            autoplayTimeoutId = null;
        }
    }
    function setupInteractions() {
        // Touch events
        container.addEventListener("touchstart", handleDragStart, {
            passive: true
        });
        container.addEventListener("touchmove", handleDragMove, {
            passive: false
        });
        container.addEventListener("touchend", handleDragEnd);
        // Mouse events for desktop drag
        container.addEventListener("mousedown", handleDragStart);
        container.addEventListener("mousemove", handleDragMove);
        container.addEventListener("mouseup", handleDragEnd);
        container.addEventListener("mouseleave", handleDragEnd);
        // Ensure hover events are set on the main carousel element
        element.addEventListener("mouseenter", ()=>{
            console.log("Mouse entered - stopping autoplay");
            isHovered = true;
            stopAutoplay();
        });
        element.addEventListener("mouseleave", ()=>{
            console.log("Mouse left - resuming autoplay");
            isHovered = false;
            startAutoplay();
        });
    }
    function handleDragStart(e) {
        isDragging = true;
        const point = e.touches ? e.touches[0] : e;
        touchStartX = point.clientX;
        startTranslate = currentTranslate;
        // Stop autoplay while dragging
        stopAutoplay();
        // Remove transition while dragging
        container.style.transition = "none";
    }
    function handleDragMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        const point = e.touches ? e.touches[0] : e;
        touchEndX = point.clientX;
        const diff = touchEndX - touchStartX;
        // Add resistance at the ends
        const resistance = 0.25;
        const moveX = diff * resistance;
        currentTranslate = startTranslate + moveX;
        container.style.transform = `translateX(${currentTranslate}px)`;
    }
    function handleDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        // Restore transition
        container.style.transition = "transform 0.3s ease-in-out";
        const movedBy = touchEndX - touchStartX;
        const threshold = slideWidth * 0.2; // 20% of slide width
        if (Math.abs(movedBy) >= threshold) {
            if (movedBy > 0) prev();
            else next();
        } else // Snap back to current slide if threshold not met
        goToSlide(currentIndex);
        // Restart autoplay after a delay
        if (autoplayOptions.enabled && !isHovered) setTimeout(startAutoplay, autoplayOptions.delay);
    }
    if (prevArrow && nextArrow) {
        prevArrow.addEventListener("click", ()=>{
            prev();
            stopAutoplay();
            if (autoplayOptions.enabled) setTimeout(startAutoplay, autoplayOptions.delay);
        });
        nextArrow.addEventListener("click", ()=>{
            next();
            stopAutoplay();
            if (autoplayOptions.enabled) setTimeout(startAutoplay, autoplayOptions.delay);
        });
    }
    if (dots.length) dots.forEach((dot, index)=>{
        dot.addEventListener("click", ()=>{
            goToSlide(index + 1);
            stopAutoplay();
            if (autoplayOptions.enabled) setTimeout(startAutoplay, autoplayOptions.delay);
        });
    });
    window.addEventListener("resize", ()=>{
        checkResponsive();
        calculateSlideWidth();
        setupSlides();
        goToSlide(currentIndex);
    });
    calculateSlideWidth();
    setupSlides();
    checkResponsive();
    setupInteractions();
    startAutoplay();
    function destroy() {
        stopAutoplay();
        element.removeEventListener("mouseenter", stopAutoplay);
        element.removeEventListener("mouseleave", startAutoplay);
    // ... any other cleanup needed
    }
    return {
        next: next,
        prev: prev,
        goToSlide: goToSlide,
        startAutoplay: startAutoplay,
        stopAutoplay: stopAutoplay,
        destroy: destroy
    };
}


function $f2528b390a96db3b$export$f1143e4c4cd76114(element, options = {}) {
    if (!element) {
        console.warn("Carousel element not found");
        return;
    }
    element.style.cssText = `
      position: relative;
      overflow: hidden;
    `;
    const container = element.querySelector(".team-carousel__container");
    const slides = Array.from(container.children);
    const prevArrow = element.querySelector(".carousel__arrow--prev");
    const nextArrow = element.querySelector(".carousel__arrow--next");
    const dots = Array.from(element.querySelectorAll(".dot"));
    const carouselOptions = {
        slidesPerView: options.slidesPerView || 3,
        spaceBetween: options.spaceBetween || 30,
        loop: true,
        breakpoints: options.breakpoints || {
            992: {
                // Desktop
                slidesPerView: 3,
                spaceBetween: 30
            },
            768: {
                // Tablet
                slidesPerView: 2,
                spaceBetween: 20
            },
            576: {
                // Mobile
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    };
    let currentIndex = 0;
    let slideWidth = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    let startTranslate = 0;
    let currentTranslate = 0;
    let autoplayTimeoutId = null;
    let isHovered = false;
    const autoplayOptions = {
        enabled: options.autoplay?.enabled ?? true,
        delay: options.autoplay?.delay ?? 5000,
        pauseOnHover: options.autoplay?.pauseOnHover ?? true
    };
    function calculateSlideWidth() {
        const containerWidth = container.offsetWidth;
        const totalSpaceBetween = (carouselOptions.slidesPerView - 1) * carouselOptions.spaceBetween;
        slideWidth = (containerWidth - totalSpaceBetween) / carouselOptions.slidesPerView;
        // Update slide widths and margins
        slides.forEach((slide)=>{
            slide.style.width = `${slideWidth}px`;
            slide.style.marginRight = `${carouselOptions.spaceBetween}px`;
        });
    }
    function setupSlides() {
        // Clear existing clones
        const clones = container.querySelectorAll(".clone");
        clones.forEach((clone)=>clone.remove());
        // Recalculate slide width
        calculateSlideWidth();
        // Instead of cloning just one slide at each end, clone enough slides to fill a view
        const slidesToClone = carouselOptions.slidesPerView;
        // Clone slides at the end
        for(let i = 0; i < slidesToClone; i++){
            const clone = slides[i].cloneNode(true);
            clone.classList.add("clone");
            container.appendChild(clone);
        }
        // Clone slides at the beginning (in reverse order)
        for(let i = slides.length - 1; i >= Math.max(slides.length - slidesToClone, 0); i--){
            const clone = slides[i].cloneNode(true);
            clone.classList.add("clone");
            container.insertBefore(clone, container.firstChild);
        }
        const allSlides = Array.from(container.children);
        allSlides.forEach((slide)=>{
            slide.style.cssText = `
        flex: 0 0 ${slideWidth}px;
        margin-right: ${carouselOptions.spaceBetween}px;
      `;
        });
        // Adjust initial position to show first real slide
        goToSlide(slidesToClone, false);
        // Clear existing dots first
        const dotsContainer = element.querySelector(".team-carousel__dots");
        if (dotsContainer) {
            dotsContainer.innerHTML = "";
            // Create correct number of dots based on actual slides
            slides.forEach((_, index)=>{
                const dot = document.createElement("button");
                dot.className = "dot";
                dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
                // Add click event listener when creating each dot
                dot.addEventListener("click", ()=>{
                    console.log("Dot clicked:", index);
                    const targetIndex = index + carouselOptions.slidesPerView;
                    console.log("Target index:", targetIndex);
                    container.style.transition = "transform 0.3s ease-in-out";
                    goToSlide(targetIndex);
                    stopAutoplay();
                    if (autoplayOptions.enabled && !isHovered) setTimeout(startAutoplay, autoplayOptions.delay);
                });
                dotsContainer.appendChild(dot);
            });
            // Reassign dots array after creating new ones
            dots.length = 0;
            dots.push(...element.querySelectorAll(".dot"));
        }
    }
    function checkResponsive() {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 576) {
            carouselOptions.slidesPerView = 1;
            carouselOptions.spaceBetween = 10;
        } else if (windowWidth <= 992) {
            carouselOptions.slidesPerView = 2;
            carouselOptions.spaceBetween = 20;
        } else {
            carouselOptions.slidesPerView = 3;
            carouselOptions.spaceBetween = 30;
        }
        calculateSlideWidth();
        setupSlides();
        goToSlide(currentIndex, false);
    }
    function updateDots(index) {
        if (dots.length) {
            dots.forEach((dot)=>dot.classList.remove("active"));
            const normalizedIndex = ((index - carouselOptions.slidesPerView) % slides.length + slides.length) % slides.length;
            dots[normalizedIndex].classList.add("active");
        }
    }
    function goToSlide(index, smooth = true) {
        console.log("Going to slide:", index);
        if (!smooth) container.style.transition = "none";
        else container.style.transition = "transform 0.3s ease-in-out";
        currentIndex = index;
        currentTranslate = -(index * (slideWidth + carouselOptions.spaceBetween));
        container.style.transform = `translateX(${currentTranslate}px)`;
        if (!smooth) setTimeout(()=>{
            container.style.transition = "transform 0.3s ease-in-out";
        }, 50);
        updateDots(index);
    }
    function next() {
        const maxIndex = slides.length + carouselOptions.slidesPerView;
        if (currentIndex >= maxIndex) {
            goToSlide(carouselOptions.slidesPerView, false);
            setTimeout(()=>goToSlide(carouselOptions.slidesPerView + 1), 50);
        } else goToSlide(currentIndex + 1);
    }
    function prev() {
        if (currentIndex <= carouselOptions.slidesPerView - 1) {
            goToSlide(slides.length + carouselOptions.slidesPerView - 1, false);
            setTimeout(()=>goToSlide(slides.length + carouselOptions.slidesPerView - 2), 50);
        } else goToSlide(currentIndex - 1);
    }
    function startAutoplay() {
        if (!autoplayOptions.enabled || isHovered) return;
        if (autoplayTimeoutId) clearTimeout(autoplayTimeoutId);
        autoplayTimeoutId = setTimeout(()=>{
            if (!isDragging && !isHovered) {
                next();
                startAutoplay();
            }
        }, autoplayOptions.delay);
    }
    function stopAutoplay() {
        if (autoplayTimeoutId) {
            clearTimeout(autoplayTimeoutId);
            autoplayTimeoutId = null;
        }
    }
    function setupInteractions() {
        // Touch events
        container.addEventListener("touchstart", handleDragStart, {
            passive: true
        });
        container.addEventListener("touchmove", handleDragMove, {
            passive: false
        });
        container.addEventListener("touchend", handleDragEnd);
        // Mouse events for desktop drag
        container.addEventListener("mousedown", handleDragStart);
        container.addEventListener("mousemove", handleDragMove);
        container.addEventListener("mouseup", handleDragEnd);
        container.addEventListener("mouseleave", handleDragEnd);
        // Ensure hover events are set on the main carousel element
        element.addEventListener("mouseenter", ()=>{
            console.log("Mouse entered - stopping autoplay");
            isHovered = true;
            stopAutoplay();
        });
        element.addEventListener("mouseleave", ()=>{
            console.log("Mouse left - resuming autoplay");
            isHovered = false;
            startAutoplay();
        });
    }
    function handleDragStart(e) {
        isDragging = true;
        const point = e.touches ? e.touches[0] : e;
        touchStartX = point.clientX;
        startTranslate = currentTranslate;
        // Stop autoplay while dragging
        stopAutoplay();
        // Remove transition while dragging
        container.style.transition = "none";
    }
    function handleDragMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        const point = e.touches ? e.touches[0] : e;
        touchEndX = point.clientX;
        const diff = touchEndX - touchStartX;
        // Add resistance at the ends
        const resistance = 0.25;
        const moveX = diff * resistance;
        currentTranslate = startTranslate + moveX;
        container.style.transform = `translateX(${currentTranslate}px)`;
    }
    function handleDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        // Restore transition
        container.style.transition = "transform 0.3s ease-in-out";
        const movedBy = touchEndX - touchStartX;
        const threshold = slideWidth * 0.2; // 20% of slide width
        if (Math.abs(movedBy) >= threshold) {
            if (movedBy > 0) prev();
            else next();
        } else // Snap back to current slide if threshold not met
        goToSlide(currentIndex);
        // Restart autoplay after a delay
        if (autoplayOptions.enabled && !isHovered) setTimeout(startAutoplay, autoplayOptions.delay);
    }
    if (prevArrow && nextArrow) {
        prevArrow.addEventListener("click", ()=>{
            prev();
            stopAutoplay();
            if (autoplayOptions.enabled) setTimeout(startAutoplay, autoplayOptions.delay);
        });
        nextArrow.addEventListener("click", ()=>{
            next();
            stopAutoplay();
            if (autoplayOptions.enabled) setTimeout(startAutoplay, autoplayOptions.delay);
        });
    }
    window.addEventListener("resize", ()=>{
        checkResponsive();
        calculateSlideWidth();
        setupSlides();
        goToSlide(currentIndex);
    });
    calculateSlideWidth();
    setupSlides();
    checkResponsive();
    setupInteractions();
    updateDots(carouselOptions.slidesPerView);
    startAutoplay();
    function destroy() {
        stopAutoplay();
        element.removeEventListener("mouseenter", stopAutoplay);
        element.removeEventListener("mouseleave", startAutoplay);
    // ... any other cleanup needed
    }
    return {
        next: next,
        prev: prev,
        goToSlide: goToSlide,
        startAutoplay: startAutoplay,
        stopAutoplay: stopAutoplay,
        destroy: destroy
    };
}


function $2c43c52bb79f4404$export$e08ac2626fff05a5() {
    const elements = document.querySelectorAll(".scroll-animate");
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("animate");
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1
    });
    elements.forEach((el)=>{
        observer.observe(el);
    });
}


class $db2f8f70fc08d83b$export$91b51442c7496f9b {
    constructor(){
        this.gallery = document.querySelector(".masonry-gallery");
        this.modal = null;
        this.currentImageIndex = 0;
        this.images = [];
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.init();
    }
    init() {
        if (!this.gallery) return;
        this.createModal();
        // Get all images and handle lazy loading
        this.images = Array.from(this.gallery.querySelectorAll("img"));
        this.images.forEach((img)=>{
            // Set initial src from data-src
            if (img.dataset.src && !img.src) img.src = img.dataset.src;
            // Add loading class
            img.classList.add("loading");
            // Remove loading class when image loads
            img.onload = ()=>{
                img.classList.remove("loading");
            };
        });
        this.initializeEventListeners();
    }
    createModal() {
        this.modal = document.createElement("div");
        this.modal.className = "masonry-modal";
        this.modal.innerHTML = `
            <div class="modal-content">
                <button class="close-btn">&times;</button>
               <button class="nav-btn prev-btn">
  <svg viewBox="0 0 24 24">
    <path d="M15 18l-6-6 6-6"/>
                    </svg>
                </button>
               <button class="nav-btn next-btn">
  <svg viewBox="0 0 24 24">
    <path d="M9 18l6-6-6-6"/>
  </svg>
</button>
                <img src="" alt="Modal Image">
            </div>
        `;
        document.body.appendChild(this.modal);
    }
    initializeEventListeners() {
        this.gallery.addEventListener("click", (e)=>{
            if (e.target.tagName === "IMG") this.openModal(Array.from(this.images).indexOf(e.target));
        });
        this.modal.querySelector(".close-btn").addEventListener("click", ()=>this.closeModal());
        this.modal.querySelector(".prev-btn").addEventListener("click", ()=>this.showImage(this.currentImageIndex - 1));
        this.modal.querySelector(".next-btn").addEventListener("click", ()=>this.showImage(this.currentImageIndex + 1));
        this.modal.addEventListener("touchstart", (e)=>{
            this.touchStartX = e.changedTouches[0].screenX;
        });
        this.modal.addEventListener("touchend", (e)=>{
            this.touchEndX = e.changedTouches[0].screenX;
            this.handleSwipe();
        });
        document.addEventListener("keydown", (e)=>{
            if (!this.modal.classList.contains("active")) return;
            if (e.key === "Escape") this.closeModal();
            if (e.key === "ArrowLeft") this.showImage(this.currentImageIndex - 1);
            if (e.key === "ArrowRight") this.showImage(this.currentImageIndex + 1);
        });
    }
    handleSwipe() {
        const swipeDistance = this.touchEndX - this.touchStartX;
        const minSwipeDistance = 50;
        if (Math.abs(swipeDistance) < minSwipeDistance) return;
        if (swipeDistance > 0) this.showImage(this.currentImageIndex - 1);
        else this.showImage(this.currentImageIndex + 1);
    }
    openModal(index) {
        this.currentImageIndex = index;
        this.modal.classList.add("active");
        this.showImage(index);
    }
    closeModal() {
        this.modal.classList.remove("active");
    }
    showImage(index) {
        if (index < 0) index = this.images.length - 1;
        if (index >= this.images.length) index = 0;
        this.currentImageIndex = index;
        const modalImg = this.modal.querySelector("img");
        const targetImage = this.images[index];
        // Use the data-src if available, otherwise use src
        modalImg.src = targetImage.dataset.src || targetImage.src;
    }
}


function $6962cd533c828913$export$d5bd5b80f649d6c() {
    const form = document.getElementById("contactForm");
    const formMessage = document.getElementById("formMessage");
    if (form) form.addEventListener("submit", $6962cd533c828913$var$handleFormSubmit);
}
function $6962cd533c828913$var$handleFormSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const formMessage = document.getElementById("formMessage");
    // Clear previous messages
    formMessage.innerHTML = "";
    formMessage.className = "contact-form__message";
    // Collect form data
    const formData = new FormData(form);
    // Ensure CSRF token is included
    const csrfToken = form.querySelector('input[name="csrf_token"]').value;
    formData.append("csrf_token", csrfToken);
    // Show loading state
    const submitButton = form.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.innerHTML;
    submitButton.innerHTML = "<span>\u0160aljem...</span>";
    submitButton.disabled = true;
    // Send the form
    fetch("process-form.php", {
        method: "POST",
        body: formData
    }).then((response)=>response.json()).then((data)=>{
        if (data.success) {
            formMessage.className = "contact-form__message contact-form__message--success";
            formMessage.textContent = data.message;
            form.reset();
        } else {
            formMessage.className = "contact-form__message contact-form__message--error";
            if (data.errors && data.errors.length) {
                const ul = document.createElement("ul");
                data.errors.forEach((error)=>{
                    const li = document.createElement("li");
                    li.textContent = error;
                    ul.appendChild(li);
                });
                formMessage.appendChild(ul);
            } else formMessage.textContent = data.message;
        }
    }).catch((error)=>{
        formMessage.className = "contact-form__message contact-form__message--error";
        formMessage.textContent = "Do\u0161lo je do gre\u0161ke. Molimo poku\u0161ajte ponovno.";
    }).finally(()=>{
        submitButton.innerHTML = originalButtonText;
        submitButton.disabled = false;
    });
}


function $0d2c10fa6b70b39a$export$4bda925ccc2b533a() {
    document.querySelectorAll(".faq-question").forEach((button)=>{
        button.addEventListener("click", ()=>{
            const expanded = button.getAttribute("aria-expanded") === "true";
            button.setAttribute("aria-expanded", !expanded);
        });
    });
}


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $8cf091426121561b$export$c92e8f569ad2976f)();
    (0, $79162cbf328500a8$export$60523367a7e10402)();
    (0, $e5a0c706c63f0a8e$export$d75bb3493b7a8511)();
    (0, $8e010fcd1137ce21$export$90bcfd3ae0065ad7)();
    (0, $ce4483e0d240611b$export$875c44e8a8aa0039)();
    (0, $2c43c52bb79f4404$export$e08ac2626fff05a5)();
    (0, $6962cd533c828913$export$d5bd5b80f649d6c)();
    (0, $0d2c10fa6b70b39a$export$4bda925ccc2b533a)();
    const imageGallery = document.querySelector(".masonry-gallery");
    if (imageGallery) // Initialize gallery
    new (0, $db2f8f70fc08d83b$export$91b51442c7496f9b)();
    // Initialize carousel with options
    const carousel = document.querySelector(".carousel");
    if (carousel) (0, $3867e9684d981eab$export$99e00de73f33b819)(carousel);
    const teamCarousel = document.querySelector(".team-carousel");
    if (teamCarousel) (0, $f2528b390a96db3b$export$f1143e4c4cd76114)(teamCarousel, {
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
            enabled: true,
            delay: 3000
        },
        breakpoints: {
            992: {
                // Desktop
                slidesPerView: 3,
                spaceBetween: 30
            },
            768: {
                // Tablet
                slidesPerView: 2,
                spaceBetween: 20
            },
            576: {
                // Mobile
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    });
});

})();
//# sourceMappingURL=app.js.map
